import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import Period from '@oberoninternal/travelbase-ds/entities/Period';
import isSameMonth from 'date-fns/isSameMonth';
import { PlannerTripFragment, TripTypeEnum } from '../generated/graphql';
import isDate from './isDate';

// new Date() === new Date() -> false, so thats why we compare the numeric values of the date
export const correctVal = (val: number | Date | undefined) => (isDate(val) ? +val : val);

export const areSamePeriods = (periodA: Period, periodB: Period) => {
    const { start: startA, end: endA } = periodA ?? {};
    const { start: startB, end: endB } = periodB ?? {};
    return correctVal(startA) === correctVal(startB) && correctVal(endA) === correctVal(endB);
};

export const getPeriodColor = (selectedTrips: PlannerTripFragment[], specialFilter: Maybe<string>) => {
    const firstSelectedTrip = selectedTrips[0];
    const { type } = firstSelectedTrip ?? {};

    if (type === TripTypeEnum.EarlyBooking || type === TripTypeEnum.LastMinute || specialFilter) {
        return 'primary';
    }

    return 'secondary';
};

export const createHasSomeMonth = (months: Date[]) => (date: Date) => months.some(month => isSameMonth(month, date));
